import firedux from '../firedux'
import {getState} from '../store'

import {
  CONVERSATIONS_PRIVATE_ENDPOINT,
  CONVERSATIONS_PRIVATE_REFS_ENDPOINT
} from '../../config/constants'

const getConversationFromState = (otherUid) => new Promise((resolve) => {
  resolve(getState().getIn(['conversations', '_refs', otherUid, 'conversationId']))
})

const getConversationRemote = (uid, otherUid, conversationId) => {
  if (conversationId) return conversationId

  const ENDPOINT = `${CONVERSATIONS_PRIVATE_REFS_ENDPOINT}/${uid}/${otherUid}/conversationId`

  return firedux.ref.child(ENDPOINT).once('value')
    .then((snapshot) => snapshot.val())
}

const createConversationIfDoesntExist = (conversationId) => {
  if (conversationId) return conversationId

  return firedux.ref.child(CONVERSATIONS_PRIVATE_ENDPOINT).push({})
    .then((ref) => ref.key())
}

const setConversationForUser = (uid, otherUid, conversationId) => {
  const ENDPOINT = `${CONVERSATIONS_PRIVATE_REFS_ENDPOINT}/${uid}/${otherUid}/conversationId`

  return firedux.ref.child(ENDPOINT).set(conversationId)
    .then(() => conversationId)
}

export const initiateGroupChatRefForUser = (uid, groupId) => {
  if (!uid || !groupId) return

  return getConversationFromState(groupId)
    .then(getConversationRemote.bind(null, uid, groupId))
    .then(setConversationForUser.bind(null, uid, groupId, groupId))
}

export default (uid, otherUid) => {
  if (!uid || !otherUid) return

  return getConversationFromState(otherUid)
  .then(getConversationRemote.bind(null, uid, otherUid))
  .then(createConversationIfDoesntExist)
  .then(setConversationForUser.bind(null, uid, otherUid))
  .then(setConversationForUser.bind(null, otherUid, uid))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/initiate_conversation.js
 **/